import type { Resource } from '@/db/types'
import { invalid } from '@/kinds/kind'
import type { DaySpec, DayStatus } from './schema'

export type DayResource = Resource<DaySpec, DayStatus>

export const defaults = (spec: Partial<DaySpec>): DaySpec => ({ date: spec.date ?? '', ...spec })

export const validate = (r: DayResource): string[] => {
  const errs: string[] = []
  if (!/^\d{4}-\d{2}-\d{2}$/.test(r.spec.date)) errs.push('date must be YYYY-MM-DD')
  const times = [r.spec.woke_at, r.spec.slept_at, r.spec.checked_in_at, r.spec.ended_at, r.spec.alarm_at]
  for (const rs of r.spec.resets ?? []) times.push(rs.start, rs.ended)
  for (const sm of r.spec.smokes ?? []) times.push(sm.at)
  for (const ts of times) if (ts && Number.isNaN(Date.parse(ts))) errs.push('times must be RFC 3339')
  for (const v of [r.spec.anxiety, r.spec.unreality, r.spec.mood])
    if (v !== undefined && (v < 0 || v > 10)) errs.push('check-in scales run 0 to 10')
  if (r.spec.alarm_at && !r.spec.alarm_text) errs.push('an alarm needs its text')
  return errs
}

export const initialStatus = (): DayStatus => ({})

export const displayName = (r: DayResource): string => r.spec.date

/** Days have no actions: wake and sleep are spec patches (mirrors internal/kinds/day). */
export const apply = (_r: DayResource, action: string): DayResource => {
  throw invalid(`unknown action ${action}`)
}
